import { useState } from "react";
import "./SideMenu.css";
import Icon from "../components/Icon";
import menuIcon from "../assets/icons/menu.svg";
import userManagementIcon from "../assets/icons/user-management.svg";
//import locationManagementIcon from "../assets/icons/location-management.svg";
import groupManagementIcon from "../assets/icons/group-management.svg";
import leaveManagementIcon from "../assets/icons/leave.svg";
import { Link } from "react-router-dom";

const SideMenu = () => {
  const [isOpen, setIsOpen] = useState(false);  

  // Toggle menu visibility
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {/* Menu Toggle Icon */}
      <button className="menu-toggle" type="button" onClick={toggleMenu} aria-label="Toggle Menu">
        <Icon src={menuIcon} alt="Toggle Menu" />
      </button>

      {/* Sliding Menu */}
      <nav className={`side-menu ${isOpen ? "open" : ""}`}>
        <ul className="menu-list">
          <li>
            <Link to="/admin/user-management">
              <Icon src={userManagementIcon} alt="User Management" />
              <span className="menu-text">User Management</span>
            </Link>
          </li>
          {/* <li>
            <Link to="/admin/location-management">
              <Icon src={locationManagementIcon} alt="Location Management" />
              <span className="menu-text">Location Management</span>
            </Link>
          </li> */}
          <li>
            <Link to="/admin/group-management">
              <Icon src={groupManagementIcon} alt="Group Management" />
              <span className="menu-text">Group Management</span>
            </Link>
          </li>
          <li>
            <Link to="/admin/leave-management">
              <Icon src={leaveManagementIcon} alt="Leave Management" />
              <span className="menu-text">Leave Management</span>
            </Link>
          </li>
        </ul>
      </nav>

      {isOpen && <div className="menu-overlay" onClick={toggleMenu}></div>}
    </>
  );
};

export default SideMenu;
